export default __webpack_public_path__ + "static/media/feature_2.7e84a9d0.png";